<!-- display-desktop-01 preview — a display ad above the article on a desktop
     publisher page. The page is a generic stand-in the whole desktop Display
     set will sit on: a serif wordmark, a nav row with the site tools opposite
     it, then the article and its lead image. The ad itself is the native unit —
     the creative flush left, and a copy column beside it carrying the headline,
     the disclosure badge with the description, the advertiser and the button. -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- The site account button, tight against the top of the window. -->
    <div class="da-account d-flex justify-content-end">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </div>

    <!-- The publisher wordmark. A stand-in logo, so it is set as text. -->
    <div class="da-wordmark">website</div>

    <!-- Site nav on the left, site tools on the right. -->
    <div class="da-nav d-flex flex-row align-items-start">
      <span
        *ngFor="let item of navItems"
        class="da-nav-item placeholder"
        aria-hidden="true"
      ></span>

      <div class="da-tools d-flex flex-row align-items-center ms-auto">
        <i class="bi bi-search" aria-hidden="true"></i>
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        <i class="bi bi-share" aria-hidden="true"></i>
        <i class="bi bi-envelope" aria-hidden="true"></i>
        <i class="bi bi-rss" aria-hidden="true"></i>
      </div>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad d-flex flex-row">
      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
        <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="da-creative-image creative-missing">{{ missingDimensionLabel }}</div>
      </a>

      <div class="da-copy">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>

        <!-- Google draws its disclosure label inside the description, and the
             text wraps back to the column edge underneath it. The mock is a
             Croatian preview and reads "Oglas" there; it stays English here
             like the other placements, since the network localises its own
             chrome at serve time. -->
        <div class="da-desc">
          <span class="da-badge">Ad</span
          >{{ data.descriptions[0] || "Your description appears here" }}
        </div>

        <div class="da-advertiser">Valamar</div>

        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta">
          <span class="da-label">{{ data.ctaText || "Your call to action" }}</span>
        </a>
      </div>

      <!-- Chrome the network draws over the unit, so it is decorative here. -->
      <i class="bi bi-info-circle da-adchoices" aria-hidden="true"></i>
    </div>
    <!-- END: Real ad -->

    <!-- The article the ad sits above, and the lead image the window cuts off. -->
    <div class="da-article">
      <div class="da-bars d-flex flex-column">
        <span
          *ngFor="let bar of bodyBars; let last = last"
          class="da-bar placeholder"
          [class.da-bar-short]="last"
          aria-hidden="true"
        ></span>
      </div>

      <div class="da-block" aria-hidden="true"></div>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
